export default __webpack_public_path__ + "static/media/carrots.690ff881.webp";